<template>

    <div class="reviews" v-if="items.length">
        <div class="review-items">
            <div class="review-item" v-for="( item, i ) in items">
                <div class="review-header">
                    <div class="rates">
                        <div class="rate-stars">
                            <template v-for="r in 5">
                                <span :class="`icon-star rate-${ r <= item.star ? 'full' : 'none' }`"></span>
                            </template>
                        </div>
                        <span class="rate-separate">|</span>
                        <span class="rate-recommend"><i class="icon-finger"></i> Would recommend</span>
                    </div>
                    <div class="review-author">
                        <span class="review-author-name">{{ item.author_name }}</span>
                        <span class="review-author-verify">
                            <i class="icon-check"></i> Verified purchase
                        </span>
                    </div>
                </div>
                <div class="review-content">
                    <div class="review-content-text">{{ item.content }}</div>
                    <div class="review-images" v-if="!!item?.images && item.images.length">
                        <div class="review-image" v-for="image in item.images">
                            <img :src="image.medium" loading="lazy">
                        </div>
                    </div>
                    <div class="review-tips">Most guests found this review helpful. Did you?</div>
                    <div class="review-likes">
                        <div
                            :class="[
                                'cursor-pointer',
                                'icon-finger',
                                item.vote === 1 ? 'user-vote' : '',
                            ]"
                            @click="rateReview( i, item.id, true )"
                        >{{ item.like }}</div>
                        <div
                            :class="[
                                'cursor-pointer',
                                'icon-finger_down',
                                item.vote === 0 ? 'user-vote' : '',
                            ]"
                            @click="rateReview( i, item.id, false )"
                        >{{ item.unlike }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-md text-center" v-if="!isLast">
            <div class="btn btn--dark-outline" @click="fetchReviews">Show more reviews</div>
        </div>
    </div>

</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: "reviews",
    data() {
        return {
            items: [],
            reviews_count: 0,
            reviews_avg: 0,
            page: 1,
            product_id: 0,
            isLoading: false, // защита от множественных запросов
            isLast: false, // если fetchReviews вернёт пустой массив, то выключаем observe
        }
    },
    mounted() {
        const product = document.querySelector('input[name="product_id"]')
        if( product ) {
            this.product_id = parseInt( product.value )
            this.fetchReviews();
        }

        // Прокручиваем наверх при загрузке
        window.addEventListener('DOMContentLoaded', () => {
            this.scrollToTop();
        });
        // Прокручиваем наверх перед выгрузкой страницы
        window.addEventListener('beforeunload', () => {
            this.scrollToTop()
        });
        // Обработка pagehide
        window.addEventListener('pagehide', () => {
            this.scrollToTop()
        });
    },
    beforeDestroy() {

    },
    methods: {
        scrollToTop() {
            window.scrollTo({top: 0});
        },
        async fetchReviews() {

            if( this.isLoading || this.isLast )
                return;

            this.isLoading = true;

            try {
                const response = await this.$http.post('/review/list', {
                    page: this.page,
                    page_size: 5,
                    product_id: this.product_id
                })

                let data = response.data.data;
                data = Array.isArray( data?.items ) ? data.items : []
                if( data.length ) {

                    if( data.length < 5 )
                        this.isLast = true;

                    this.items.push( ...(
                        data.filter( item => {
                            // Уточняем условие фильтрации
                            return ! this.items.some( existingItem => existingItem.id === item.id );
                        } )
                    ) );
                } else {
                    this.isLast = true;
                }

                this.page++;
            } catch (err) {
                console.error('error: ', err)
            } finally {
                this.isLoading = false;
            }
        },

        async rateReview( i,  id, like = true) {

            if( this.isLoading )
                return;

            this.isLoading = true;

            try {
                const response = await this.$http.post('/review/like', {id: id, like: like})
                // Достаём данные из ответа
                const { status, code, data } = response.data;
                const message = data?.message;
                if( message ) {
                    const alertMethod = this.$alert[ status ];
                    if( typeof alertMethod === 'function' ) {
                        alertMethod( message );
                    } else {
                        this.$alert.info( message );
                    }
                }

                // Обновляем данные при успешном статусе
                if( status === 'success' && data?.stats ) {
                    const item = this.items.find( item => item.id === id );
                    if (item) {
                        item.like = data.stats.like ?? item.like;
                        item.unlike = data.stats.unlike ?? item.unlike;
                        item.vote = data.vote ?? item.vote;
                    } else {
                        console.warn(`element with id=${id} not found in items list`);
                    }
                }
            } catch (err) {
                console.error('error: ', err)
            } finally {
                setTimeout( () => {
                    this.isLoading = false;
                }, 500 )
            }
        }
    }
})
</script>

<style scoped>

</style>